import { createStore } from 'vuex'
import * as mutations from './mutations'
import * as getters from './getters'
import * as actions from './actions'
import currentPricingRequestObj from './currentPricingRequestObj'

export default createStore({
  state: {
    view: 'workspace', // 'workspace' or 'overview'
    viewCapture: null,
    auth: {
      user: {
        id: '',
        display_name: '',
        impersonating: false,
        productAccess: {
          apm: false,
          epm: false,
          pprSettings: false,
        },
      },
      shares: [],
      utilities: [],
      userInputUtilities: [],
      plan: {
        name: "Free Use",
        slug: "free" ,
      },
      products: {
        pricingCalculator: {},
        pricingReports: [],
      },
    },
    registered: false,
    nav: {
      visible: false,
    },
    isLoadingSavedPriceRequests: false,
    facilityProfilesUtilityId: null,
    facilityProfiles: {},
    customFacilityProfileColumns: {},
    inlineFacilityPath: [],
    currentPricingRequest: Object.assign({}, currentPricingRequestObj),
    lastLoadedPricingRequest: {},
    savedPricingRequests: [],
    pricingRequestStatus: '',
    batchDatesTotal: 0,
    batchDatesRemaining: 0, 
    currentBatch: 0,
    currentPricingData: {
      data: {},
      totals: {},
      requestId: null,
    },
    currentPricingChartLockedDate: undefined,
    plans: {},
    planConfig: {
      maxTerms: 1,
      allowCustomTerms: false,
      restrictStartMonth: true,
      allowCustomFacilityProfile: false,
      priceRequestSlots: false,
      exportable: false,
    },
    activeListeners: [],
    dashboardSortUtility: false,
    dashboardPricingComponents: [],
    tempCustomFacilityProfile: {},
    allowPricingRequestSubmission: false,
    declineBrokerFee: false,
    submitPricingRequestHover: false,
    currentFacilityCategory: {},
    customFacilityProfileView: false,
    customFacilityProfileUiStep: 'meta',
    collapseCustomFacilityProfileTable: false,
    expandAllPricingRows: false,
    currentPricingChartData: {},
    notification: {
      type: '',
      msg: '',
      title: '',
    },
    acceptTermsOfUse: false,
    userBranding: {
      colorHex: null,
      logoUrl: null,
      appliesTo: {
        app: false,
        product: false,
      }
    },
  },
  mutations,
  getters,
  actions,
  strict: process.env.NODE_ENV !== 'production',
})
